import { CurrencyRateDetails } from 'further-types/lp/transaction';
import { round } from 'lodash';

export default function calculateTcyValue(
  lcyValue: number,
  currencyRate?: CurrencyRateDetails | null,
) {
  if (!lcyValue) {
    return 0;
  }
  if (!currencyRate) {
    return lcyValue;
  }

  return round(
    lcyValue * (currencyRate.overrideRate ?? currencyRate.fetchedRate ?? 1),
    2,
  );
}
